'use client';

import { c as _c } from "react/compiler-runtime";
import { baseUrl } from '@utils/utils-config';
import { ExperienceStructuredData } from 'src/lib/structured-data/experience';
import type { ProductReviewSummary } from 'src/lib/trusted-shops/product-reviews';
import { useAppExperienceAvailableDates } from '../_hooks/use-app-experience-available-dates';
import { useAppExperiencePurchasableDays } from '../_hooks/use-app-experience-purchasable-days';
import { useAppExperienceTimeslotsPreview } from '../_hooks/use-app-experience-timeslots-preview';
import { type HeadlinePrice, headlinePrice } from '../_lib/day-prices';
import { getExperiencePriceFromOffers, getExperienceStructuredOffers } from '../_lib/experience-structured-offers';
import { useExperienceFilterContext } from './app-experience-filter-provider';
export function AppExperienceStructuredData(t0) {
  const $ = _c(27);
  const {
    reviewSummary,
    description,
    price
  } = t0;
  const {
    experience,
    baseVariants,
    filter,
    dayPrice,
    dayPriceFailed,
    dayPriceIsPreliminary
  } = useExperienceFilterContext();
  const appointments = experience.experienceType !== "ticket";
  const preview = useAppExperienceTimeslotsPreview(appointments);
  const {
    shownDates: dates,
    prices
  } = preview;
  const available = useAppExperienceAvailableDates(experience.publicId, filter.selectedVariant, filter.selectedOptions, appointments);
  const tickets = useAppExperiencePurchasableDays(experience, !appointments && !experience.alwaysAvailable);
  const previewPending = preview.isLoading || preview.isPlaceholderData || preview.isError || prices.arePreliminary || prices.isError || dayPriceFailed;
  let t1;
  if ($[0] !== appointments || $[1] !== baseVariants || $[2] !== dates || $[3] !== experience || $[4] !== filter || $[5] !== previewPending || $[6] !== prices) {
    t1 = !appointments || previewPending ? [] : getExperienceStructuredOffers({
      ...experience,
      variants: baseVariants
    }, filter, dates, prices.dayPrices);
    $[0] = appointments;
    $[1] = baseVariants;
    $[2] = dates;
    $[3] = experience;
    $[4] = filter;
    $[5] = previewPending;
    $[6] = prices;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const exactOffers = t1;
  const availabilityPending = appointments ? previewPending || available.isLoading || available.isPreliminary || available.isError : !experience.alwaysAvailable && (tickets.isLoading || tickets.isError);
  const bookable = appointments ? !!available.availableDates?.length : experience.alwaysAvailable || tickets.purchasableDays.length > 0;
  const unbookable = appointments ? "MadeToOrder" : "OutOfStock";
  const availability = bookable ? "InStock" : unbookable;
  let t2;
  if ($[8] !== availability || $[9] !== availabilityPending || $[10] !== dayPrice || $[11] !== dayPriceFailed || $[12] !== dayPriceIsPreliminary || $[13] !== exactOffers || $[14] !== experience || $[15] !== price) {
    t2 = exactOffers.length || availabilityPending || dayPriceFailed || dayPriceIsPreliminary ? exactOffers : getExperiencePriceFromOffers(experience, headlinePrice(price, dayPrice), availability);
    $[8] = availability;
    $[9] = availabilityPending;
    $[10] = dayPrice;
    $[11] = dayPriceFailed;
    $[12] = dayPriceIsPreliminary;
    $[13] = exactOffers;
    $[14] = experience;
    $[15] = price;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const offers = t2;
  let t3;
  if ($[17] !== description || $[18] !== experience) {
    t3 = {
      ...experience,
      description
    };
    $[17] = description;
    $[18] = experience;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const t4 = `/erlebnisse/${experience.publicId}/${experience.slug}/`;
  let t5;
  if ($[20] !== t4) {
    t5 = baseUrl(t4);
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== offers || $[23] !== reviewSummary || $[24] !== t3 || $[25] !== t5) {
    t6 = <ExperienceStructuredData experience={t3} canonicalUrl={t5} offers={offers} reviewSummary={reviewSummary} />;
    $[22] = offers;
    $[23] = reviewSummary;
    $[24] = t3;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}